export type AssetWithDisplayDate =
  | {
      parent?: { __typename?: string; displayDate?: string | null } | null;
      displayDate?: string | null;
    }
  | null
  | undefined;

/**
 * Retrieves the upload display date from an asset's displayDate GraphQL field.
 *
 * The `displayDate` field is resolved on the backend and should already apply
 * any fallback logic needed to produce the upload date.
 *
 * @param asset - Asset with optional displayDate
 * @returns ISO date string or null if not available
 */
export function getUploadDisplayDate(
  asset: AssetWithDisplayDate
): string | null {
  if (!asset) return null;

  return asset?.displayDate ?? null;
}
